import React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { sessionActions } from '../../actions/user/sessionActions';

const SessionExpiredModal = ({ expired, dismiss }) => (
    <Modal show={expired} onHide={dismiss} centered>
        <Modal.Header closeButton>
            <Modal.Title>Session expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Your session has expired or you are no longer authorized. Please log in again.
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={dismiss}>OK</Button>
        </Modal.Footer>
    </Modal>
);

const mapStateToProps = (state) => {
    return {
        expired: state.users.session.expired
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dismiss: () => dispatch(sessionActions.sessionExpiredDismiss())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionExpiredModal);
